/**
 * Trend Line Chart Component
 * ტრენდის ხაზოვანი ჩარტი
 */

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import type { TimeSeriesPoint } from '../../../features/api/adminStatistics';

interface TrendLineChartProps {
  data: TimeSeriesPoint[];
  title: string;
  color?: string;
  height?: number;
}

export default function TrendLineChart({
  data,
  title,
  color = '#6366f1',
  height = 300,
}: TrendLineChartProps) {
  const formattedData = data.map((point) => ({
    date: new Date(point.date).toLocaleDateString('ka-GE', { // chart axis: short format
      month: 'short',
      day: 'numeric',
    }),
    value: point.value,
  }));

  return (
    <div>
      <h3 className="text-sm font-medium text-gray-600 mb-4">{title}</h3>
      <ResponsiveContainer width="100%" height={height}>
        <LineChart data={formattedData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="date"
            tick={{ fill: '#6b7280', fontSize: 12 }}
            axisLine={{ stroke: '#e5e7eb' }}
          />
          <YAxis
            tick={{ fill: '#6b7280', fontSize: 12 }}
            axisLine={{ stroke: '#e5e7eb' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
            }}
          />
          <Line
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={2}
            dot={{ fill: color, strokeWidth: 2 }}
            activeDot={{ r: 6, fill: color }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
